"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smsGodo = void 0;
exports.smsGodo = function (axios) {
    return {
        putSmsGodoCancelReserve: function (putSmsGodoCancelReserve) {
            return axios.put('/sms/godo/cancel-reserve', putSmsGodoCancelReserve.data, putSmsGodoCancelReserve);
        },
        getSmsGodoCallingNumbers: function (getSmsGodoCallingNumbersRequest) {
            return axios.get('/sms/godo/calling-numbers', getSmsGodoCallingNumbersRequest);
        },
        getSmsGodoPoint: function (getSmsGodoPointRequest) {
            return axios.get('/sms/godo/point', getSmsGodoPointRequest);
        },
        putSmsGodoSettings: function (putSmsGodoSettingsRequest) {
            return axios.put('/sms/godo/settings', putSmsGodoSettingsRequest.data, putSmsGodoSettingsRequest);
        },
        getSmsGodoSends: function (getSmsGodoSendsRequest) {
            return axios.get('/sms/godo/sends', getSmsGodoSendsRequest);
        },
        postSmsGodoSend: function (postSmsGodoSendRequest) {
            return axios.post('/sms/godo/send', postSmsGodoSendRequest.data, postSmsGodoSendRequest);
        },
        getSmsGodoReservedHistory: function (getSmsGodoReservedHistoryRequest) {
            return axios.get('/sms/godo/reserved-send-histories', getSmsGodoReservedHistoryRequest);
        },
        getSmsGodoTokenPopupPointCharge: function (getSmsGodoTokenPopupPointChargeRequest) {
            return axios.get('/sms/godo/popup/point-charge', getSmsGodoTokenPopupPointChargeRequest);
        },
        getSmsGodoTokenPopupSmsDetail: function (getSmsGodoTokenPopupSmsDetailRequest) {
            return axios.get('/sms/godo/popup/send-detail', getSmsGodoTokenPopupSmsDetailRequest);
        },
        postSmsPostRecipientExcel: function (postSmsRecipientExcelRequest) {
            return axios.post("/sms/godo/recipient/excel?mallNo=" + postSmsRecipientExcelRequest.params.mallNo, postSmsRecipientExcelRequest.data);
        },
        getSmsGodoAuth: function (request) {
            return axios.get('/sms/godo/auth', request);
        },
        postSmsGodoAuth: function (request) {
            return axios.post("/sms/godo/auth?mallNo=" + request.params.mallNo);
        },
    };
};
